import { AxiosResponse } from 'axios';
import ClientAxios from '../../client';
import { ResponseValidator } from '../../response-validator';
import { ErrorWrapperHandler } from '../../error-wrapper-handler';
import { LandingPageUrl } from '../../urls';
import {
  GetLandingPageOutputWrapperInterface,
  GetLandingPageOutputInterface,
} from '../../interfaces/landing-page/get-landing-page';

export async function GetLandingPageMutation(): Promise<GetLandingPageOutputWrapperInterface> {
  try {
    const response: AxiosResponse<GetLandingPageOutputWrapperInterface> =
      await ClientAxios.get(LandingPageUrl);
    return ResponseValidator(response.data);
  } catch (error) {
    return ErrorWrapperHandler<GetLandingPageOutputInterface>(error);
  }
}
